import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import getSelectionPlugins from './getSelectionPlugins';

export default class SelectionToolbar extends BaseExtension {
  get type(): string {
    return extensionType.toolbar;
  }

  get name(): string {
    return 'selection_menu';
  }

  plugins(options: EditorOptions) {
    return getSelectionPlugins()(options);
  }
}
